<template>
  <div class="componentBox">
    <h2 class="componentTitle">饲养信息</h2>
    <h3 class="littleTitle">饲养信息</h3>
    <Cell :colList="feedInfoCell" :detail="feedDetail" />
    <a-table class="tableBox" :columns="feedInfoMeatColumns" :data-source="feedList" :pagination="false">
      <template slot="weight" slot-scope="t">
        {{ t=='-' ? t : t?.toFixed(2)}}
      </template>
      <template slot="num" slot-scope="t">
        {{ t?.toFixed(2)}}
      </template>
    </a-table>
    <Cell :colList="feedStageCell" :detail="feedDetail" />
    <h3 class="littleTitle">饲养阶段</h3>
    <a-table class="tableBox" :columns="feedStageMeatColumns" :data-source="poultryLineMeatRaiseInfos" :pagination="false">
      <template slot="stageType" slot-scope="t">
        {{ stagesObj[t] }}
      </template>
      <template slot="productName" slot-scope="t,r">
        <a v-if="r.nhfFormulaId && detail.poultryLineCustomerInfo.createUser == staffId" @click="() => productDetail(r)">{{ t }}</a>
        <span v-else>{{ t }}</span>
      </template>
      <template slot="modelName" slot-scope="t">{{ t ? t : '-' }}</template>
      <template slot="feedTerminalPrice" slot-scope="t">
        {{ t.toFixed(2)}}
      </template>
      <template slot="feedCost" slot-scope="t">
        {{ t?.toFixed(2)}}
      </template>
    </a-table>
    <h3 class="littleTitle">生产结果</h3>
    <Cell :colList="productionResultsCell" :detail="poultryLineMeatProductResult" :len="2"/>
    <h3 class="littleTitle">经济效益</h3>
    <Cell :colList="economicBenefits" :detail="poultryLineMeatProductResult" :len="2"/>
  </div>
</template>

<script>
import Cell from './Cell.vue';
import {feedInfoMeatColumns,feedStageMeatColumns} from '../Columns'
export default {
  components: {Cell},
  props: ['detail'],
  data() {
    return {
      stagesObj: {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
      },
      feedInfoMeatColumns,
      feedStageMeatColumns,
      feedInfoCell: [
        {title: '饲养品种',field: 'feedVariety',},
        {title: '饲料品牌',field: 'feedBrand',},
        {title: '出栏方式',field: 'outType',},
        {title: '苗价(元/只)',field: 'seedlingPrice',},
        {title: '售卖单价(元/斤)',field: 'hairyPrice',},
      ],
      feedStageCell: [],
      productionResultsCell: [
        {title: '成活率（%）',field: 'survivalRate',},
        {title: '出栏日龄（天）',field: 'outAge',},
        {title: '耗料量（斤/只）',field: 'feedCost',},
        {title: '出栏体重（斤/只）',field: 'avgOutWeight',},
        {title: '料重比',field: 'weightCostRatio',},
        {title: '日增重（g/只）',field: 'avgWeightIncrement',},
        {title: '日采食（g/只）',field: 'avgFeed',},
        {title: '欧指',field: 'europeanEfficiencyIndex',},
      ],
      economicBenefits: [
        {title: '饲料单价（元/吨）',field: 'feedPrice',},
        {title: '饲料成本（元/只）',field: 'feedCostPrice',},
        {title: '单只收益（元/只）',field: 'hairyChickenEarnings',},
        {title: '净收益（元）',field: 'pureSaleProfit',},
        {title: '客户增值（元/只）',field: 'customerIncrement',},
      ],
      staffId:''
    }
  },
  watch: {
    // detail:{
    //   handler(){
    //     this.feedDetail()
    //   },
    //   deep: true
    // }
  },
  computed: {
    feedDetail() {
      let obj = {...this.detail.poultryLineMeatFeedInfo}
      return obj
    },
    feedList() {
      let {intoDay,intoNum,outDay,outWeight,outNum} = this.detail.poultryLineMeatFeedInfo || {}
      let feedList = [
        {state: '入栏',day: intoDay,weight: '-',num: intoNum},
        {state: '出栏',day: outDay,weight: outWeight,num: outNum},
      ]
      return feedList
    },
    poultryLineMeatRaiseInfos(){
      return this.detail.poultryLineMeatRaiseInfos || []
    },
    poultryLineMeatProductResult(){
      let {poultryLineMeatFeedInfo={},poultryLineMeatProductResult = {}} = this.detail || {}
      let obj = {...poultryLineMeatProductResult || {}}
      obj.totalWeight = poultryLineMeatFeedInfo.outWeight
      return obj
    },
  },
  created() {},
  mounted() {this.staffId=window.localStorage.getItem('staffId')},
  methods: {
    productDetail(record){
      this.$http.get(`/nhf-app/api/sat/collect/formula/actions/check?formulaId=${record.nhfFormulaId}`).then(res => {
        if(res.code == 200){
          this.$router.push({
            path: '/nhf-compound-editor',
            query: {
              id: record.nhfFormulaId
            }
          })
        }
      })
    },
  },
}
</script>
<style lang='scss'></style>
<style lang='scss' scoped></style>